var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-blue height28 border-radius4 padding-left12 padding-right12 flex-center color-white ComButton",on:{"click":_vm.btnClick}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }